export interface ICurrency {
    name: string;
    icon: string;
    shortIcon: string;
}

export const currenciesList: ICurrency[] = [
    {
        name: "USD",
        shortIcon: "$",
        icon: "$",
    },
    {
        name: "GBP",
        shortIcon: "£",
        icon: "£",
    },
    {
        name: "EUR",
        shortIcon: "€",
        icon: "€",
    },
    {
        name: "JPY",
        shortIcon: "¥",
        icon: "¥",
    },
    {
        name: "AUD",
        shortIcon: "$",
        icon: "AU$ ",
    },
];

export const DEFAULT_CURRENCY = currenciesList[0].name;
